import { render, staticRenderFns } from "./ShowNoticeContent.vue?vue&type=template&id=066cbf38&"
import script from "./ShowNoticeContent.vue?vue&type=script&lang=js&"
export * from "./ShowNoticeContent.vue?vue&type=script&lang=js&"
import style0 from "./ShowNoticeContent.vue?vue&type=style&index=0&lang=scss&scroped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('066cbf38')) {
      api.createRecord('066cbf38', component.options)
    } else {
      api.reload('066cbf38', component.options)
    }
    module.hot.accept("./ShowNoticeContent.vue?vue&type=template&id=066cbf38&", function () {
      api.rerender('066cbf38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/ShowNoticeContent.vue"
export default component.exports